// CRO Controller – step 1: stub implementation.
import CROService from "@services/cro.service.js";
import Config from "@config";
import { getSession } from "@hooks/useSession";
import State, {CurrentEntityState} from "@state";

/**
 * Create CRO company entity via Oshimed API & platform backend.
 * For now only forwards data to service. More validation will be added later.
 * @param {object} companyData  raw form data from CROCreateCompanySignUp page
 * @returns {Promise<object>} API response or standard error object
 */
const createCompany = async (companyData) => {
  try {
    if (!companyData) {
      return {
        success: false,
        message: "No data provided",
        errorCode: "cro-no-data",
        errorKey: 234567,
      };
    }

    // Basic required fields validation
    const requiredFields = [
      "companyName",
      "street",
      "number",
      "country",
      "city",
      "postalCode",
      "regNumber",
      "contactNumber",
    ];
    const missing = requiredFields.find(
      (f) => !companyData[f] || !companyData[f].trim()
    );
    if (missing) {
      return {
        success: false,
        message: `Missing field ${missing}`,
        errorCode: "cro-missing-field",
        errorKey: 345778,
      };
    }

    // Retrieve session for didAddress & apiToken if needed later in service
    const { user, apiToken } = getSession() || {};
    if (!user?.didAddress) {
      return {
        success: false,
        message: "Missing user didAddress in session",
        errorCode: "cro-no-did",
        errorKey: 345779,
      };
    }

    // Transform data to API payload shape
    const payload = {
      entityType: "cro",
      entityData: {
        servicesOffered: [""],
        regionsOperated: [""],
        therapeuticAreas: [""],
        certifications: [""],
        contact: {
          entityName: companyData.companyName,
          entityDescription: "",
          legalStructure: "Corporation",
          phoneNumber: companyData.contactNumber,
          email: user.email || "",
          postalAddress: `${companyData.street} ${companyData.number}`.trim(),
          zipCode: companyData.postalCode,
          country: companyData.country,
          city: companyData.city,
          company_number: (companyData.company_number ?? companyData.regNumber ?? "").trim(),
        },
      },
    };

    // Forward to service
    const result = await CROService.createCompany(payload);

    console.log('=== result === cro.controller.js === key: 667885 ===');
    console.dir(result, { depth: null, colors: true })
    console.log('=================================');

    const entityId = result?.webhook?.response?.data?.entityId;
    const entityData = result?.webhook?.response?.data?.entityData;
    
    State.setValue(CurrentEntityState.CURRENT_ENTITY_ID, entityId);
    State.setValue(CurrentEntityState.CURRENT_ENTITY_DATA, entityData);

    return result;
  } catch (error) {

    console.log('=== error === cro.controller.js === key: 805827 ===');
    console.dir(error, { depth: null, colors: true })
    console.log('=================================');

    if (!Config.IN_PROD) console.error("[cro.controller]", error);
    return {
      success: false,
      message: "Unexpected error while creating company",
      fromError: error,
      errorCode: "cro-create-error",
      errorKey: 904211,
    };
  }
};

export default {
  createCompany,
};
